import { SOCKET_EVENTS } from "constants/app.constant";
import { createContext, useEffect, useState, useRef } from "react";
import useSocket from "utils/hooks/useSocket";

export const chatContext = createContext();

// Track if user has interacted with the page
let userInteracted = false;

const initializeAudio = () => {
  userInteracted = true;
};

const playNotificationSound = () => {
  // Only play sound if user has interacted with the page
  if (!userInteracted) {
    console.log("Sound skipped: User has not interacted with page yet");
    return;
  }

  try {
    const audio = new Audio("/sound.mp3");
    audio.volume = 0.5;

    audio.play().catch((error) => {
      console.log("Audio play failed:", error);
    });
  } catch (error) {
    console.error("Error playing notification sound:", error);
  }
};

function ChatProvider({ children }) {
  const socket = useSocket();
  const [activeChat, setActiveChat] = useState(null);

  // Initialize audio on first user interaction
  useEffect(() => {
    const handleUserInteraction = () => {
      initializeAudio();
      // Remove listeners after first interaction
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };

    // Add multiple event listeners to catch any interaction
    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("touchstart", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("touchstart", handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    if (!socket?.current) return;

    const handleNewMessage = (msg) => {
      const incomingUserId = msg?.candidateData?._id;
      const activeUserId = activeChat?.candidateId?._id;

      if (!activeUserId || incomingUserId !== activeUserId) {
        if (!("Notification" in window)) return;
        console.log({ msg });
        if (Notification.permission === "granted") {
          new Notification(`📬 New Message from ${msg?.candidateInfo?.name}`, {
            body: msg?.message || "You have a new message",
            icon: "/logobg.png",
          });

          // Play sound only if user has interacted
          if (userInteracted) {
            playNotificationSound();
          }
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
              new Notification(
                `📬 New Message from ${msg?.candidateInfo?.name}`,
                {
                  body: msg?.message || "You have a new message",
                  icon: "/logobg.png",
                }
              );

              if (userInteracted) {
                playNotificationSound();
              }
            }
          });
        }
      }
    };

    socket.current.on(SOCKET_EVENTS.MESSAGE_RECIEVED, handleNewMessage);

    return () => {
      socket.current.off(SOCKET_EVENTS.MESSAGE_RECIEVED, handleNewMessage);
    };
  }, [activeChat, socket]);

  return (
    <chatContext.Provider value={{ activeChat, setActiveChat, socket }}>
      {children}
    </chatContext.Provider>
  );
}

export default ChatProvider;
